import { Reveal, ChapterLabel } from "@/components/site/Reveal";
import { FIRST_AID_STEPS } from "@/lib/content";
import { AlertCircle } from "lucide-react";

const accents = [
  "bg-brand-pink",
  "bg-brand-orange",
  "bg-brand-green",
  "bg-brand-pink",
  "bg-brand-orange",
];

export default function ErsteHilfe() {
  return (
    <section
      id="erste-hilfe"
      data-testid="section-erste-hilfe"
      className="relative py-20 md:py-32 bg-cream-alt"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <ChapterLabel index={2} label="Bitte sofort tun" color="text-brand-pink" />

        <Reveal className="mt-6 max-w-3xl">
          <h2 className="font-heading font-bold text-ink text-3xl md:text-4xl lg:text-5xl tracking-tight">
            Du hast einen Igel gefunden?
          </h2>
          <p className="mt-4 text-lg md:text-xl leading-relaxed text-ink-muted">
            Keine Sorge – mit diesen fünf Schritten hilfst du deinem kleinen
            Findling am besten. Ruhig bleiben, das schaffst du.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {FIRST_AID_STEPS.map((step, i) => (
            <Reveal
              key={step.n}
              delay={i * 0.08}
              data-testid={`first-aid-step-${step.n}`}
              className="relative rounded-[2rem] bg-white p-8 md:p-9 shadow-soft border border-ink/5 transition-transform duration-300 hover:-translate-y-1.5"
            >
              <div
                className={`${accents[i]} w-14 h-14 rounded-full flex items-center justify-center text-white font-heading font-extrabold text-2xl shadow-soft`}
              >
                {step.n}
              </div>
              <h3 className="mt-6 font-heading font-bold text-xl md:text-2xl text-ink">
                {step.title}
              </h3>
              <p className="mt-3 text-base md:text-lg leading-relaxed text-ink-muted">
                {step.text}
              </p>
            </Reveal>
          ))}

          <Reveal
            delay={0.4}
            className="rounded-[2rem] bg-brand-green p-8 md:p-9 shadow-card flex flex-col justify-center"
          >
            <AlertCircle className="w-10 h-10 text-white/90" />
            <p className="mt-4 font-heading font-bold text-xl md:text-2xl text-white leading-snug">
              Im Zweifel immer lieber einmal zu viel fragen.
            </p>
            <p className="mt-2 text-white/85 text-base md:text-lg">
              Ich bin für dich und den Igel da.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
